"use client";
import React, { useState } from "react";
import { MdOutlineFileDownload } from "react-icons/md";
import mockUp from "../images/brochureMockUp.png";

// ✅ Fix TypeScript error for react-icons
const DownloadIcon = MdOutlineFileDownload as unknown as React.FC<
  React.SVGProps<SVGSVGElement>
>;

const Brochure = () => {
  const [isDownloading, setIsDownloading] = useState(false);

  const handleDownload = () => {
    setIsDownloading(true);

    const link = document.createElement("a");
    link.href = "https://www.whitefieldmissions.org/haystack/resources/haystackBrochure2025.pdf";
    link.download = "haystackBrochure2025.pdf";
    link.click();

    setTimeout(() => setIsDownloading(false), 1500);
  };

  return (
    <div className="brochuregrad min-h-screen flex flex-col-reverse lg:flex-row justify-center items-center gap-12 px-6 sm:px-10 md:px-24 py-14 downloadBg">
      
      {/* Image Block */}
      <div className="flex justify-center lg:justify-start w-full lg:w-auto">
        <img
          src={mockUp}
          alt="Conference Brochure"
          className="w-[260px] sm:w-[360px] md:w-[460px] lg:w-[520px] drop-shadow-xl"
        />
      </div>

      {/* Text Block */}
      <div className="flex flex-col gap-6 text-center lg:text-left max-w-[700px]">
        <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-clashMedium leading-tight text-gray-900 tracking-tight">
          Download the Haystack Conference 2025 Brochure
        </h1>

        {/* Download Button */}
        <button
          onClick={handleDownload}
          disabled={isDownloading}
          className={`flex justify-center items-center w-fit mx-auto lg:mx-0 px-4 sm:px-8 py-3 rounded-lg font-medium gap-2 text-lg sm:text-xl transition-all shadow-md ${
            isDownloading
              ? "bg-gray-400 cursor-not-allowed"
              : "bg-[#EFC66F] hover:scale-105 text-black hover:shadow-lg"
          }`}
        >
          {isDownloading ? (
            <>
              <svg
                className="animate-spin h-5 w-5 text-white"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
              >
                <circle
                  className="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="4"
                ></circle>
                <path
                  className="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                ></path>
              </svg>
              <span>Downloading...</span>
            </>
          ) : (
            <>
              <DownloadIcon className="text-2xl sm:text-3xl" />
              <span>Download Brochure</span>
            </>
          )}
        </button>
      </div>
    </div>
  );
};

export default Brochure;
